// libs
import { Wallet } from "lucide-react";

// hooks
import useUserData from "../../hooks/useUserData";
import useAppData from "../../hooks/useAppData";

// styles
import classes from "./styles.module.css";
import { useEffect } from "react";

export default function Header() {
  const { userData, isAdmin } = useUserData();
  const { appData, getAppData } = useAppData();

  useEffect(() => {
    getAppData();
  }, []);

  if (!isAdmin || !userData || !appData) {
    return;
  }

  return (
    <div className={classes.root}>
      <div className={classes.bar}>
        <span className={classes.left}>
          <Wallet className={classes.icon} />
          Баланс: {appData.balance} ֏
        </span>

        <span className={classes.right}>
          <span className={classes.dot} />@{userData.username} ({userData.role})
        </span>
      </div>
    </div>
  );
}
